<div class="uk-container uk-container-expand">
  <div class="uk-card uk-card-default uk-margin-medium-top uk-margin-medium-bottom">
    <!-- HEADER -->
    <div class="uk-card-header uk-padding-small primary-background">
      <div class="uk-grid-small uk-flex uk-flex-middle">
        <div>
          <h3 class="colored-text uk-margin-remove">Session {{ headerData ? ' - ' + headerData.p_libelle : '' }}</h3>
          <p class="colored-text uk-margin-remove">
            Session du {{ (headerData ? headerData.min : '') | date: 'dd/MM/yyyy' }} au
            {{ (headerData ? headerData.max : '') | date: 'dd/MM/yyyy' }}
            <span class="uk-margin-small-left primary-background-darker argalis-badge"
              >N° {{ headerData ? headerData.reference : '' }}</span
            >
          </p>
          <div id="emargement-intervenant" class="input-field colored-text uk-margin-remove" [hidden]="!moduleGdeActiv">
            <label class="label">Lien de connexion à la page d'émargement : </label>
            <a class="colored-text" target="_blank" href="{{ urlEmargement }}">{{ urlEmargement }}</a>
            <a
              class="colored-text"
              (click)="copyToClipboard()"
              onclick="UIkit.notification({message: 'Adresse copiée dans le presse-papier', pos: 'top-right'})"
              uk-tooltip="Copier dans le presse-papier"
            >
              <i class="material-icons">content_copy</i>
            </a>
          </div>
        </div>
        <div class="uk-text-align uk-margin-auto-left">
          <button kendoButton class="primary-darken" (click)="goBack()" uk-tooltip="Page précédente">
            <span uk-icon="icon: arrow-left" class="colored-text"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- SOUS-TITRE -->
    <div class="uk-width-1-1 uk-padding-small uk-background-muted">
      <ags-session-sous-titre [idSession]="idSession.toString()"></ags-session-sous-titre>
    </div>

    <!-- CORPS -->
    <div class="card-content" uk-grid>
      <!-- SUB-MENU -->
      <div class="uk-width-auto@m sidebar-session uk-margin-medium-bottom" *ngIf="!loadMenu">
        <kendo-menu
          id="kendo-menu"
          #menu
          [menuItemLinkTemplate]=""
          [hoverDelay]="1"
          (select)="selectMenu($event)"
          [items]="menuData"
          [vertical]="true"
        ></kendo-menu>
      </div>

      <!-- CONTENT -->
      <div class="uk-width-expand@m">
        <ags-session-information [idSession]="idSession.toString()" *ngIf="selectedMenu === 'synthese'"></ags-session-information>
        <ags-session-planning [idSession]="idSession.toString()" *ngIf="selectedMenu === 'planning'"></ags-session-planning>
        <ags-session-apprenant [idSession]="idSession.toString()" *ngIf="selectedMenu === 'apprenant'"></ags-session-apprenant>
        <ags-session-consigne
          [idSession]="idSession.toString()"
          [listMenu]="listConsignes"
          *ngIf="selectedMenu === 'consigne'"
        ></ags-session-consigne>
        <ags-session-presence [idSession]="idSession.toString()" *ngIf="selectedMenu === 'presence'"></ags-session-presence>
        <ags-session-prerequis [idSession]="idSession.toString()" *ngIf="selectedMenu === 'prerequis'"></ags-session-prerequis>
        <ags-session-evaluation [idSession]="idSession.toString()" *ngIf="selectedMenu === 'evaluation'"></ags-session-evaluation>
        <ags-session-habilitation
          [idSession]="idSession.toString()"
          *ngIf="selectedMenu === 'habilitation'"
        ></ags-session-habilitation>
        <ags-session-rapport-intervenant
          [idSession]="idSession.toString()"
          *ngIf="selectedMenu === 'rapport'"
        ></ags-session-rapport-intervenant>
        <ags-session-document [idSession]="idSession.toString()" *ngIf="selectedMenu === 'document'"></ags-session-document>
        <ags-session-carte-achat [idSession]="idSession.toString()" *ngIf="selectedMenu === 'carte'"></ags-session-carte-achat>
      </div>
    </div>
  </div>
</div>
